module.exports = __webpack_public_path__ + "img/why-head.b09c624b.svg";